import { createFileRoute, redirect } from '@tanstack/react-router';

import { envConfig } from '#constants/envConfig';

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard/_authed')({
  beforeLoad: async ({ context, location }) => {
    if (context.authStatus === 'ok' && !context.isAuth) {
      // The app boots from a prerendered shell, and that shell was built with nobody signed in
      // — `isAuth: false` is baked into it. On the web the server re-evaluates it per request;
      // in the app the first render inherits the snapshot, so a returning user with a perfectly
      // good token was bounced to sign-in on every cold start. Ask storage before believing it.
      if (envConfig.IS_NATIVE) {
        const { getNativeToken } = await import('#features/api/utils/nativeAuth');
        if (await getNativeToken()) {
          return;
        }
      }
      // Preserve the page the user was trying to reach so sign-in can send them back
      // afterwards (deep links from notifications/Discord land here when logged out).
      throw redirect({ to: '/{-$locale}/sign-in', search: { redirect: location.href } });
    }
  },
});
